import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { useWidgetDispatch, useWidgetSelector } from "../../../store/store";
import { WidgetContext } from "../../../../../../main/layout/layout";
import { prevPane } from "../../../store/actions";
import { State } from "../../../store/state";
import styles from "./ProgressBar.module.scss";
export const ProgressBar: React.FC<{
  inline?: boolean;
  numberOfPanes?: number;
}> = t0 => {
  const $ = _c(22);
  const {
    inline,
    numberOfPanes: t1
  } = t0;
  const numberOfPanes = t1 === undefined ? 4 : t1;
  const dispatch = useWidgetDispatch();
  const paneNumber = useWidgetSelector(_temp);
  const [widgetContext, setWidgetContext] = useContext(WidgetContext);
  const hideBackButton = paneNumber === 0;
  let points;
  if ($[0] !== numberOfPanes || $[1] !== paneNumber) {
    points = [];
    for (let i = 0; i < numberOfPanes; i++) {
      points.push(<div key={i} className={paneNumber >= i ? `${styles.circle} ${styles.circleFilled}` : styles.circle} />);
    }
    $[0] = numberOfPanes;
    $[1] = paneNumber;
    $[2] = points;
  } else {
    points = $[2];
  }
  const t2 = hideBackButton ? `${styles.actionButton} ${styles.actionButtonHidden}` : styles.actionButton;
  let t3;
  if ($[3] !== dispatch) {
    t3 = e => {
      dispatch(prevPane());
      e.currentTarget.blur();
    };
    $[3] = dispatch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hideBackButton || $[6] !== t2 || $[7] !== t3) {
    t4 = <button data-cy="back-button" disabled={hideBackButton} className={t2} onClick={t3}>←</button>;
    $[5] = hideBackButton;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== points) {
    t5 = points.map(_temp2);
    $[9] = points;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.line} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <div className={styles.progress}>{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== inline || $[15] !== setWidgetContext || $[16] !== widgetContext) {
    t8 = !inline && <button className={styles.actionButton} data-cy="close-widget" onClick={e_0 => {
      setWidgetContext({
        ...widgetContext,
        open: false
      });
      e_0.currentTarget.blur();
    }}>✕</button>;
    $[14] = inline;
    $[15] = setWidgetContext;
    $[16] = widgetContext;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className={styles.header}>{t4}{t7}{t8}</div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
function _temp(state) {
  return state.layout.paneNumber;
}
function _temp2(p) {
  return p;
}